import { ref, readonly } from 'vue';

export interface CameraPlayerState {
  cameraId: string | number;
  cameraName: string;
}

const isOpen = ref(false);
const current = ref<CameraPlayerState | null>(null);

// Position / size state (persisted to localStorage)
const STORAGE_KEY = 'otto-camera-pip';

function loadPosition() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    /* ignore */
  }
  return { x: window.innerWidth - 360, y: window.innerHeight - 260, w: 340, h: 220 };
}

function savePosition(pos: { x: number; y: number; w: number; h: number }) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pos));
  } catch {
    /* ignore */
  }
}

const position = ref(loadPosition());

export function useCameraPlayer() {
  function open(state: CameraPlayerState) {
    current.value = state;
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
    current.value = null;
  }

  function updatePosition(pos: Partial<{ x: number; y: number; w: number; h: number }>) {
    Object.assign(position.value, pos);
    savePosition(position.value);
  }

  return {
    isOpen: readonly(isOpen),
    current: readonly(current),
    position,
    open,
    close,
    updatePosition,
  };
}
